const seasonsSliders = document?.querySelectorAll(
  ".peach-seasons.seasons-section"
);
seasonsSliders?.forEach((elem) => {
  const sliderEl = elem?.querySelector(".keen-slider");
  const items = sliderEl?.querySelectorAll(".season");
  const nextBtn = elem?.querySelector(".next");
  const prevBtn = elem?.querySelector(".prev");
  const slides = sliderEl?.querySelectorAll("li");
  const activeSlider =
    slides?.length > 0
      ? [...slides]?.findIndex((el) => el?.classList?.contains("active"))
      : 1;

  items?.forEach((item) => {
    item?.addEventListener("mouseover", function () {
      items?.forEach((item) => {
        item?.classList?.remove("active");
      });
      item?.classList?.add("active");
    });
  });

  if (sliderEl) {
    const slider = new KeenSlider(sliderEl, {
      initial: activeSlider || 1,
      breakpoints: {
        "(max-width: 800px)": {
          slides: { perView: 2 },
        },
        "(max-width: 520px)": {
          slides: { perView: 1 },
        },
      },
      slides: {
        perView: "auto",
      },
      slideChanged(slide) {
        const currentSlide = [...items]?.[slider?.track?.details?.rel];
        if (currentSlide) {
          items?.forEach((item) => {
            item?.classList?.remove("active");
            currentSlide?.classList?.add("active");
          });
        }
      },
    });
    nextBtn?.addEventListener("click", function () {
      slider.next();
    });
    prevBtn?.addEventListener("click", function () {
      slider.prev();
    });
  }
});
